import type { JSX } from 'react';

import type { StarfishIconRef } from '@/app/common/icons/starfish';

export type TooltipRenderProps = {
  isOpen: boolean;
  isMobile: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export enum FeatureType {
  dates = 'dates',
  bold = 'bold',
  normal = 'normal',
  primary = 'primary',
  waiting = 'waiting',
  danger = 'danger',
  offer = 'offer',
  offerGray = 'offerGray',
  gray = 'gray',
  link = 'link',
  dotted = 'dotted',
}

type BaseFeature = {
  text?: string | null;
  /**
   * A named icon the row will draw. A plain string is a local multi-colour
   * asset (the lastminute deals and Pink People artwork, TSH), which a
   * single-colour design system glyph cannot reproduce.
   */
  icon?: StarfishIconRef | string;
  iconRight?: StarfishIconRef | string;
  gridSide?: 'left' | 'right';
  order?: number;
  className?: string;
  link?: <T extends unknown[]>(...args: T) => void;
  Modal?: ({
    isOpen,
    onClose,
  }: {
    isOpen: boolean;
    onClose: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  }) => JSX.Element | null;
  Popover?: ({ anchorEl }: { anchorEl: HTMLElement | null }) => JSX.Element | null;
  Tooltip?: (props: TooltipRenderProps) => JSX.Element | null;
  callback?: () => void;
};

type RegularFeature = BaseFeature & {
  featureType: Exclude<FeatureType, FeatureType.waiting>;
};

export type WaitingFeature = BaseFeature & {
  featureType: FeatureType.waiting;
  loaderWidth?: number;
  loaderHeight?: number;
  gridSide?: 'left' | 'right';
};

export type Feature = RegularFeature | WaitingFeature;

export const waitingItem: WaitingFeature = {
  text: '',
  className: 'loader',
  featureType: FeatureType.waiting,
};

export const waitingFlightItem: WaitingFeature = {
  text: '',
  className: 'loader flight',
  featureType: FeatureType.waiting,
};

export const waitingDateItem: WaitingFeature = {
  text: '',
  className: 'loader date',
  featureType: FeatureType.waiting,
};
